module.exports = __webpack_public_path__ + "img/ios_model_100.923f2894.png";